<template>
  <div ref="modal" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document" style="max-width: 98% !important;">
      <div class="modal-content">
        <div class="modal-header">
        <div v-if="this.void_type == 'void_load'">
          <h5 class="modal-title">Void Load {{ data?.load_id }}</h5>
        </div>
        <div v-if="this.void_type == 'void_order'">
          <h5 class="modal-title">Void Order {{ data?.order_no }}</h5>
        </div>

          
          <button type="button" class="btn-close" data-bs-dismiss="modal" v-on:click="$emit('closeModal')"
            aria-label="btn-close"></button>
        </div>

        <div class="modal-body">
          <form ref="formElement">
            <div class="row">

                 <div class="form-group row">
                    <label for="staticReason" class="col-sm-2 col-form-label">Void Type <span style="color: red;">*</span></label>
                    <div class="col-sm-10">
                        
                        <input type="radio" :id="this.$dynamicId()" value="void_load" v-model="void_type" />&nbsp;&nbsp;
                        <label for="void_load">Void Load</label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <input type="radio" :id="this.$dynamicId()" value="void_order" v-model="void_type" />&nbsp;&nbsp;
                        <label for="void_load">Void Order</label>

                    </div>
                </div>


                <!-- this for void load -->
                <div v-if="this.void_type == 'void_load'">
                    
                  <div class="form-group row">
                      <label for="staticReason" class="col-sm-2 col-form-label">Reason <span style="color: red;">*</span></label>
                      <div class="col-sm-10">
                          <select class="form-select form-select-sm" v-model="reject_description_load" :id="this.$dynamicId()" required>
                            <option v-for="option in reasonsLoad" :value="option.value" :key="option.value">
                              {{ option.value }}
                            </option>
  

                          </select>
                      </div>
                  </div>

                  <div class="form-group row">
                      <label for="staticReason" class="col-sm-2 col-form-label">Comments <span style="color: red;">*</span></label>
                      <div class="col-sm-10">
                          <textarea v-model="void_overide_remarks" class="form-control" :id="this.$dynamicId()" rows="3" minlength="10" required></textarea>
                      </div>
                  </div>

                  <div style="padding-top: 5% !important;"></div>

                  <div class="table-responsive">

                    <table class="table">

                      <thead style="background-color:red;">
                          <tr>
                              <th style="color: white;text-align: center; padding: 1%;"><span>Load ID</span></th>
                              <th style="color: white;text-align: center; padding: 1%;"><span>#Stops <br> #Total Weight <br> #Distance </span></th>
                              <th style="color: white;text-align: center; padding: 1%;"><span>SKU</span></th>
                              <th style="color: white;text-align: center; padding: 1%;"><span>Origin</span></th>
                              <th style="color: white;text-align: center; padding: 1%;"><span>Pick Date</span></th>
                              <th style="color: white;text-align: center; padding: 1%;"><span>Destination</span></th>
                              <th style="color: white;text-align: center; padding: 1%;"><span>Drop Date</span></th>
                              <th style="color: white;text-align: center; padding: 1%;"><span>Current Status</span></th>
                          </tr>
                      </thead>

                      <tbody>

                         <tr>
                          <td> {{data.load_id}} </td>
                          <td> {{this.dataCalculateLoad.stops}} <br> {{toFixed(this.dataCalculateLoad.totalWeight)}} kg <br> {{toFixed(this.dataCalculateLoad.distance)}} km</td>
                          <td> {{data.sku}} </td>
                          <td> {{this.dataCalculateLoad.origin}} </td>
                          <td> {{this.dataCalculateLoad.pick_date}} </td>
                          <td> {{this.dataCalculateLoad.destionation}} </td>
                          <td> {{this.dataCalculateLoad.drop_date}} </td>
                          <td> {{this.dataCalculateLoad.current_status}} </td>
                        </tr>

                         <tr>
                          <td>  </td>
                          <td colspan="7">  

                              <table class="table">
                                  <tr style="background-color:red;">
                                      <!-- <td style="text-align: center; padding: 1%;"><span><input type="checkbox" v-model="allSelected" @change="selectAll" /></span> </td> -->
                                      <td style="color: white;text-align: center; padding: 1%;"><span>Order No</span></td>
                                      <td style="color: white;text-align: center; padding: 1%;"><span>Shipwith Ref</span></td>
                                      <td style="color: white;text-align: center; padding: 1%;"><span>Origin</span></td>
                                      <td style="color: white;text-align: center; padding: 1%;"><span>Pick Date</span></td>
                                      <td style="color: white;text-align: center; padding: 1%;"><span>Destination</span></td>
                                      <td style="color: white;text-align: center; padding: 1%;"><span>Drop Date</span></td>
                                      <td style="color: white;text-align: center; padding: 1%;"><span>Action</span></td>
                                  </tr>
                                  <tr v-for="(item,index) in this.dataCalculateLoad.details" :key="index">
                                      <!-- <td style="padding-top: 1%; padding-bottom: 1%;"> <span style="text-align: center; padding-top: 12%; padding-bottom: 1%;"> <input type="checkbox" :id="'item-' + item.transport_order_header_id" :value="item.transport_order_header_id" v-model="selectedIds" @change="updateSelectAll"/> </span> </td> -->
                                      <td> {{ item.order_no }} </td>
                                      <td style="padding-top: 1%; padding-bottom: 1%;" > <span >  {{ item.shipwith_ref }} </span> </td>
                                      <td style="padding-top: 1%; padding-bottom: 1%;"> <span> {{ item.pick_name }} </span> </td>
                                      <td style="padding-top: 1%; padding-bottom: 1%;"> <span> {{ getDateFromString(item.pick_plan) }} </span> </td>
                                      <td style="padding-top: 1%; padding-bottom: 1%;"> <span> {{ item.dest_name }} </span> </td>
                                      <td style="padding-top: 1%; padding-bottom: 1%;"> <span> {{ getDateFromString(item.dest_plan) }} </span> </td>
                                      <td style="padding-top: 1%; padding-bottom: 1%;"> <span> Set to Unassigned </span> </td>
                                  </tr>
                              </table>

                          </td>
                        </tr>

                      </tbody>

                      
                    </table> 
 
                  </div>

                </div>
                <!-- this for void load -->


                <!-- this for void order -->
                <div v-if="this.void_type == 'void_order'">
                    
                  <div class="form-group row">
                      <label for="staticReason" class="col-sm-2 col-form-label">Reason <span style="color: red;">*</span></label>
                      <div class="col-sm-10">
                          <select class="form-select form-select-sm" v-model="reject_description" :id="this.$dynamicId()" required>
                            <option v-for="option in reasons" :value="option.value" :key="option.value">
                              {{ option.value }}
                            </option>
  

                          </select>
                      </div>
                  </div>

                  <div class="form-group row">
                      <label for="staticReason" class="col-sm-2 col-form-label">Comments <span style="color: red;">*</span></label>
                      <div class="col-sm-10">
                          <textarea v-model="void_overide_remarks" class="form-control" :id="this.$dynamicId()" rows="3" minlength="10" required></textarea>
                      </div>
                  </div>

                  <div style="padding-top: 5% !important;"></div>

                  
                  <div class="table-responsive">

                      <table class="table">

                          <thead style="background-color:red;">
                              <tr>
                                  <th><span style="color: white;">Load ID</span></th>
                                  <th><span style="color: white;">Order No</span></th>
                                  <th><span style="color: white;">Shiftwithref</span></th>
                                  <th><span style="color: white;">Weight</span></th>
                                  <th><span style="color: white;">Volume</span></th>
                                  <th><span style="color: white;">Customer</span></th>
                              </tr>
                          </thead>
                          <tbody>

                              <tr>
                                  <td>{{data.load_id}}</td>
                                  <td>{{data.order_no}}</td>
                                  <td>{{data.shipwith_ref}}</td>
                                  <td>{{data.tonnage}}</td>
                                  <td>{{data.cubic}}</td>
                                  <td>{{data.company_name}}</td>
                              </tr>


                              <tr>
                                  <td colspan="2"> <h4> Schedules Origin </h4> </td>
                                  <td> <h4> Planned Ship Date </h4> </td>
                                  <td colspan="2"> <h4> Destination </h4> </td>
                                  <td> <h4> Planned Deliv Date </h4> </td>
                              </tr>
                              <tr>
                                  <td colspan="2"> 
                                      {{ data.pick_name }} <br> 
                                      {{ data.pick_address1 }} <br> 
                                      {{ data.pick_address2 }} <br> 
                                      {{ data.pick_district }} <br> 
                                      {{ data.pick_city }} <br> 
                                      {{ data.pick_province+' , '+data.pick_postal_code+' , '+data.pick_country }} 
                                  </td>
                                  <td> {{ $moment(data.pick_plan).format("D MMM yyyy") }}  </td>
                                  <td colspan="2"> 
                                      {{ data.dest_name }} <br> 
                                      {{ data.dest_address1 }} <br> 
                                      {{ data.dest_address2 }} <br> 
                                      {{ data.dest_district }} <br> 
                                      {{ data.dest_city }} <br> 
                                      {{ data.dest_province+' , '+data.dest_postal_code+' , '+data.dest_country }}  
                                  </td>
                                  <td> {{ $moment(data.dest_plan).format("D MMM yyyy") }}  </td>
                              </tr>
                              <tr>
                                  <td colspan="6"> <input type="checkbox" v-model="checked_reroute"> Reroute Order ini ke order no lain</td>
                              </tr>
                              <tr v-if="checked_reroute == true">

                                <td colspan="6">
                                  <table class="table">
                                    <tr>
                                      <td colspan="8"> <h5>Reroute To Existing Order</h5> </td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"><div style="background-color: #e39191;width: 100%;border: 2px solid #fc0505;padding: 2%;margin: 1%;"> 
                                         <h5> <i class="mdi mdi-information" style="color: blue !important;"></i> Untuk membatalkan order ini dan memindahkannya ke order lain pada Load ID ini, masukkan nomor order tujuan pada dropdown New Order di bawah!</h5>
                                      </div> </td>
                                    </tr>
                                    <tr style="height:100px;">
                                        <td style="height:100%;"><b> Current Order </b>  </td>
                                        <td style="width: 10px;">  </td>
                                        <td colspan="6"> <span style="color: gray;"> {{ data.load_id +' - '+data.order_no }} </span> </td>
                                    </tr>
                                    <tr style="height:50px;">
                                        <td style="height:100%;"> <b> New Order </b> </td>
                                        <td style="width: 10px;">  </td>
                                        <td colspan="6">  
                                          <multiselect v-model="new_transport_order_header_id" :options="fetchOrderNo" @input="changeOrderNo" @open="removeReadonly"
                                            ref="inputOrderNo" @search-change="asyncDataOrderNo" placeholder="Please Select Order No" label="order_no"
                                            track-by="order_no">
                                          </multiselect>
                                        </td>
                                    </tr> 
                                    <tr v-if="this.rowOrderNo" style="background-color:red;">
                                      <th><span style="color: white;">Load ID</span></th>
                                      <th><span style="color: white;">Order No</span></th>
                                      <th><span style="color: white;">Shiftwithref</span></th>
                                      <th><span style="color: white;">Origin</span></th>
                                      <td><span style="color: white;">Planned Ship Date</span></td>
                                      <th><span style="color: white;">Destination</span></th>
                                      <th><span style="color: white;">Planned Deliv Date</span></th>
                                      <th><span style="color: white;">Customer</span></th>
                                  </tr>
                                  <tr v-if="this.rowOrderNo">
                                      <td>{{this.rowOrderNo.load_id}}</td>
                                      <td>{{this.rowOrderNo.order_no}}</td>
                                      <td>{{this.rowOrderNo.shipwith_ref}}</td>
                                      <td>
                                        
                                      {{ this.rowOrderNo.pick_name }} <br> 
                                      {{ this.rowOrderNo.pick_address1 }} <br> 
                                      {{ this.rowOrderNo.pick_address2 }} <br> 
                                      {{ this.rowOrderNo.pick_district }} <br> 
                                      {{ this.rowOrderNo.pick_city }} <br> 
                                      {{ this.rowOrderNo.pick_province+' , '+this.rowOrderNo.pick_postal_code+' , '+this.rowOrderNo.pick_country }}  

                                      </td>
                                      <td> {{ $moment(this.rowOrderNo.pick_plan).format("D MMM yyyy") }}  </td>
                                      <td>
                                        
                                      {{ this.rowOrderNo.dest_name }} <br> 
                                      {{ this.rowOrderNo.dest_address1 }} <br> 
                                      {{ this.rowOrderNo.dest_address2 }} <br> 
                                      {{ this.rowOrderNo.dest_district }} <br> 
                                      {{ this.rowOrderNo.dest_city }} <br> 
                                      {{ this.rowOrderNo.dest_province+' , '+this.rowOrderNo.dest_postal_code+' , '+this.rowOrderNo.dest_country }} 

                                      </td>
                                      <td> {{ $moment(this.rowOrderNo.dest_plan).format("D MMM yyyy") }}  </td>
                                      <td>{{this.rowOrderNo.company_name}}</td>
                                  </tr>

                                  </table>
                                </td>
                              </tr>

                          </tbody>

                      </table>

                  </div>


                </div>

                <!-- /this for void order -->


          
            </div>
          </form>
 



        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" v-on:click="$emit('closeModal')">
            cancel
          </button>
         <button v-if="void_type != ''" class="btn btn-success" type="submit" v-on:click="saveAssign">
          <span v-if="isLoading" class="spinner-border spinner-border-sm ms-auto" role="status" aria-hidden="true"></span> 

          <span v-if="checked_reroute && void_type == 'void_order'">
            SIMPAN & Reroute
          </span>

          <span v-else-if="void_type == 'void_order'">
            SIMPAN
          </span>

          <span v-else-if="void_type == 'void_load'">
            SIMPAN
          </span>
        </button>
        </div>

      </div>
    </div>
 

  </div>


</template>

<script>
import multiselect from "vue-multiselect";
 
export default {
  components: {
    "multiselect": multiselect
  },
  name: "ModalPointLoad",
  emits: ["closeModal"],
  props: {
    showModal: Boolean,
    data: null,
  },
  watch: {
    showModal: {
      handler(newVal) {
            
        const formElement = this.$refs.formElement;
        if (formElement) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'readonly') {
                const inputs = formElement.querySelectorAll('.multiselect__input');
                inputs.forEach(input => {
                  input.removeAttribute('readonly');  // Hapus readonly setiap kali diubah
                });
              }
            });
          });

          const inputs = formElement.querySelectorAll('.multiselect__input');
          inputs.forEach(input => {
            observer.observe(input, { attributes: true });
          });
        }

        this.dataCalculateLoad = [];
        this.selectedIds= [];
        this.checked_reroute = false;
        this.asyncDataOrderNo('');
        this.getReason();
        this.getCalculateLoad();
      
          this.active = newVal;
        const body = document.querySelector("body");
        this.showModal
          ? body.classList.add("modal-open")
          : body.classList.remove("modal-open");
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
        selectedIds: [],
        allSelected:true,
        selectedDetails:[],
        void_type:'',
        reasons             : [],
        reasonsLoad             : [],
        reject_description  : "",
        reject_description_load  : "",
        void_overide_remarks: "",
        new_transport_order_header_id:"",
        cheklist_driver : true,
        driver_number   : '',
        disabledRadioButton: false,
        vehicle_no_disabled: false,
        driver_disabled: false,
        dataSendToModalAdd: '',
        type_: '',
        showModalAdd: false,
        classColapsed: '',
        isLoading: false,
        active: this.showModal,
        forms: [],
        showTabelShipmentToExisting: false,
        load_id: "",
        fetchOrderNo: [],
        checked_reroute:false,
        trailer_no: "",
        branch_id_ship_ex: "",
        branch_name_ship_ex: "",
        carrier_ship_ex: "",
        driver_hp_ship_ex: "",
        driver_name_ship_ex: "",
        driver_nmk_ship_ex: "",
        driver_number_ship_ex: "",
        type_truck_ship_ex: "",
        type_truck_id_ship_ex: "",
        vehicle_no_ship_ex: "",
        name_ship_ex: "",
        rowOrderNo:false,

        errors: [],
        locale: [],
        fetch_new_transport_order_header_id: [],
        auto_load: "",
        report_date: [],
        pickup_date: "",
        delivery_date: "",
        groupByCategory: [],
        type_error: [],
        rows: [],
        prioritycek: [],
        activePriority_1: false,
        activePriority_2: false,
        activePriority_3: false,
        activePriority_4: false,
        activePriority_5: false,
        activePriority_6: false,
        activePriority_7: false,
        activePriority_8: false,
        activePriority_9: false,
        activePriority_10: false,
        dataPriority_1: [],
        dataPriority_2: [],
        dataPriority_3: [],
        dataPriority_4: [],
        dataPriority_5: [],
        dataPriority_6: [],
        dataPriority_7: [],
        dataPriority_8: [],
        dataPriority_9: [],
        dataPriority_10: [],
        fetchDriver: [],
        driver: "",
        unit: "own",
        fetchVehicleNo: [],
        vehicle_no: "",
        transporter: "",
        typeTruck: "",
        fetchTypeTruck: [],
        fetchTransporter: [],
        vehicle_no_vendor: "",
        driver_vendor: "",
        fetchVehicleNoVendor: [],
        fetchDriverVendor: [],
        fetchLookupCode: [],
        remark_dest_customer: '',
        container: '',
        dataCalculateLoad: {
          stops:0,
          totalWeight:0,
          distance:0,
        },
    };
  },
  methods: {

    selectAll() {
      if (this.allSelected) {
        // If "Select All" is checked, populate selectedIds with all item IDs
        this.selectedIds = this.dataCalculateLoad.details.map(item => item.transport_order_header_id);
      } else {
        // If "Select All" is unchecked, clear the selectedIds array
        this.selectedIds = [];
      }
    },
    
    updateSelectAll() {
      // Update the "Select All" checkbox state based on the individual checkboxes
      if (this.selectedIds.length === this.dataCalculateLoad.details.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    },

    getDateFromString(datetimeString) {

      return datetimeString.substring(0, 10);

    },

    toFixed(val){
      let data = parseFloat(val).toFixed(2).replace('.', ',');

      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")

    },

    getCalculateLoad(){


      let dataSend = {
        load_id:this.data.load_id,
        sku:this.data.sku,
        pick_name:this.data.pick_name,
        dest_name:this.data.dest_name,
      };

      const baseURI = this.$settings.endPoint + `void-order/calculate-load`;
        return this.$http.post(baseURI,dataSend).then((response) => { 
          this.dataCalculateLoad = response.data.datas;

          let details = response.data.datas.details;
          if(details.length > 0){

            details.forEach((item) => {
              this.selectedIds.push(item.transport_order_header_id); // Pushing to another array
            });

          }

      });

    },

    removeReadonly() {
      this.$nextTick(() => {
        const input = this.$refs.inputOrderNo.$el.querySelector(
          ".multiselect__input"
        );
        if (input && input.hasAttribute("readonly")) {
          input.removeAttribute("readonly");
        }
      });
    },

    changeOrderNo(ev) {
      console.log(ev);
      this.rowOrderNo = ev;
    },

    getReason(){

      const baseURI = this.$settings.endPoint + `void-order/get-reason-status`;
        return this.$http.get(baseURI).then((response) => {
          // console.log(response.data)
          this.reasons = response.data.datas;
          this.reasonsLoad = response.data.datas;
      });

    },

    asyncDataOrderNo(ev) {
      // console.log(ev)
      this.fetchOrderNo = [];
      this.rowOrderNo   = false;
      const baseURI =
        this.$settings.endPoint + `void-order/get-transport-order-header?limit=5&load_id=`+this.data.load_id+`&orderno=`+this.data.order_no+`&order_no=` + ev;
        return this.$http.get(baseURI).then((response) => {
        this.fetchOrderNo = response.data.datas.data;
      });
    },
     
    success2(msg) {
      this.$swal({
        icon: 'info',
        backdrop: true,
        title: "Information",
        html: "<p>* " + msg + "</p>",
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    },


    errorAlert(msg) {
      this.$swal({
        icon: 'danger',
        backdrop: true,
        title: "Information",
        html: "<p>* " + msg + "</p>",
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    },


     
    alert(msg) {

      let pesan = '';

      if(msg.length > 0){

        msg.forEach((psn) => {
            pesan = pesan + '<br> id : ' + psn.order_no + ' , status : ' + psn.status
        });

      }

      this.$swal({
        icon: 'info',
        backdrop: true,
        title: "Information",
        html: "<p>* " + pesan + "</p>",
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    },
 
    saveAssign() {
        this.isLoading = true;

        if(this.void_type == 'void_order'){


          if (this.void_overide_remarks.length === 0) {
            this.isLoading = false;
            return this.error("Comments wajib di isi");
          }

          if (this.reject_description.length === 0) {
            this.isLoading = false;
            return this.error("Reason wajib di pilih");
          }

          var dataSend = {};
          
          dataSend = {

              "void_overide_remarks": this.void_overide_remarks,
              "reject_description": this.reject_description,
              "reroute": this.checked_reroute,
              "new_transport_order_header_id": this.rowOrderNo.transport_order_header_id

          };

          let baseURI = this.$settings.endPoint + "void-order/send/" + this.data.transport_order_header_id;

          return this.$http
            .post(
              baseURI,
              dataSend,
              { timeout: 10000 }
            )
            .then((response) => {


              if (response.status == 200) {
                this.checked_reroute = false;
                this.isLoading = false;
                this.errors = [];
                this.success2('Success Save data !!');
                this.$emit("closeModal");
              }

                this.dataCalculateLoad = [];
                this.selectedIds= [];



            })
            .catch(error => {
              this.isLoading = false;

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
                return;
              }

              if (error.response) {
        
                if (error.response.status === 422) {
                  
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);

                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else if (error.response.status === 401) {
                  this.$router.push("/authorized-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });

        }else if(this.void_type == 'void_load'){

          var selectedIdsLength = this.selectedIds.length;
 
          if(selectedIdsLength <= 0 ){
            this.isLoading = false;
            return this.error("Mohon pilih order yang akan di VOID");
          }

          if (this.void_overide_remarks.length === 0) {
            this.isLoading = false;
            return this.error("Comments wajib di isi");
          }

          if (this.reject_description_load.length === 0) {
            this.isLoading = false;
            return this.error("Reason wajib di pilih");
          }
          
          var dataSendLoad = {
            "void_overide_remarks": this.void_overide_remarks,
            "reject_description": this.reject_description_load,
            "transport_order_header_ids": this.selectedIds
          };

          let baseURI = this.$settings.endPoint + "void-order/send-load";

          return this.$http
            .post(
              baseURI,
              dataSendLoad,
              { timeout: 10000 }
            )
            .then((response) => {

              if (response.status == 200) {
                this.checked_reroute = false;
                this.isLoading = false;
                this.errors = [];
                this.alert(response.data.datas);
                this.$emit("closeModal");
              }

              this.dataCalculateLoad = [];
              this.selectedIds= [];



            })
            .catch(error => {
              this.isLoading = false;

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
                return;
              }

              if (error.response) {
        
                if (error.response.status === 422) {
                  
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);

                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else if (error.response.status === 401) {
                  this.$router.push("/authorized-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });

        }else{

          this.error("Silahkan Pilih Void yang di Sediakan");

        }


    },


    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    error(kata) {
      this.$swal.fire({
        icon: "error",
        title: "Perhatian!",
        text: kata,
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6", // bisa diganti warna sesuai selera
        position: "center",
      });
    },
  
   
 



  },
  mounted() {

    
 
  },
};
</script>

<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background: #fff;
  border-radius: 0px;
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  padding: 0px;
  width: 100%;
  height: 100%;
  margin-left: 0px !important;
}
/* Important part */
.modal-dialog{
    overflow-y: initial !important
}
.modal-body{
    height: 80vh;
    overflow-y: auto;
}
</style>